var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({staticClass:"flex items-center",on:{"click":_vm.click}},'button',_vm.attrs,false),[(_vm.loading)?_c('div',{staticClass:"spinner mr-2"}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }